import { render, staticRenderFns } from "./integrationList.vue?vue&type=template&id=3145368c&scoped=true&v-if=lang%20%26%26%20__(title)&"
import script from "./integrationList.vue?vue&type=script&lang=js&"
export * from "./integrationList.vue?vue&type=script&lang=js&"
import style0 from "./integrationList.scss?vue&type=style&index=0&id=3145368c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3145368c",
  null
  
)

export default component.exports